import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import StyledObserved from '../styles/Forecast';

import H2 from '../styles/H2';

const Observed = ({ hourly }) => {
  return (
    <StyledObserved>
      <H2>Observed (Last 5 days)</H2>
      <div className='observer-container'>
        {hourly.map((singleHour) => {
          const time = moment.unix(singleHour.dt).format('HH.mm');

          const date = moment.unix(singleHour.dt).format('MM-DD');
          const singleImgSrc = `http://openweathermap.org/img/wn/${singleHour.weather[0].icon}@2x.png`;

          return (
            <div key={singleHour.dt} className='observed-item'>
              <p>{date}</p>
              <p>{time}</p>
              <img src={singleImgSrc} alt="Observed Icon" />
              <p>{singleHour.temp}&deg;</p>
            </div>
          );
        })}
      </div>
    </StyledObserved>
  );
};

Observed.propTypes = {
  hourly: PropTypes.array.isRequired,
};

export default Observed;
